import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../Context/AuthContext';

export default function EmployeePrivateRoute( { children }) {
    const { currentUser } = useAuth();
    const location = useLocation();
    // console.log(currentUser?.admin);
    return currentUser?.admin ? children : <Navigate to="/employee-login" state={{from: location}} />;
}